export const VISIT_REPORT_EXPORT_ID = 'visit-report';
export const VISIT_REPORT_TITLE = 'Reporte de Visitas';

export const VISIT_REPORT_DETAIL_EXPORT_ID = 'report-detail-visit-list';
export const VISIT_REPORT_DETAIL_TITLE = 'Reporte de Detalle de Visitas';

export const LOCALIZED_PROPERTIES = {
  trip: 'Viaje',
  route: 'Ruta',
  user: 'Usuario',
  day: 'Día',
  visitDay: 'Visita Día',
  visitaExtraRuta: 'ExtraRuta',
  visitaEfectuada: 'Efectuada',
  visitaFaltante: 'Faltante',
  percent_visit: '% de Visita',
  visitaEfectiva: 'Visita Efectiva',
  efectividad: '% de Efectividad',
  totalRouteDurationHours: 'Duración Ruta',
  totalVisitDurationHours: 'Tiempo Efectivo',
  tripDurationHoursTeoric: 'Duración E',
  tripDurationHours: 'Duración R',
};
